import {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
} from "@angular/router";

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: {}): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): {} {
    return {};
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }

    if (JSON.stringify(future.params) !== JSON.stringify(curr.params)) {
      return false;
    }

    if (this.hasReLoadParent(future)) {
      return true;
    }

    return false;
  }

  private hasReLoadParent(route: ActivatedRouteSnapshot | null): boolean {
    if (!route) return false;

    if (route.routeConfig?.reLoadParent === false) {
      return true;
    }

    return this.hasReLoadParent(route.firstChild ?? null);
  }
}
